import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import store from './store'
import VueCookies from 'vue-cookies'
import VueLazyload from 'vue-lazyload'
import './registerServiceWorker'



import './plugins/axios'
import particles from 'particles.js'
Vue.use(particles)


//css
import './css/';

VueCookies.config('30d')


// lazy load
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: '/images/error.png',
    loading: '/images/loading.jpg',
    attempt: 1
})



router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})



Vue.config.productionTip = false


new Vue({
    router,
    i18n,
    store,
    VueCookies,
    VueLazyload,
    render: h => h(App)
}).$mount('#app')
